import { render, staticRenderFns } from "./companiesSettings.vue?vue&type=template&id=8c4b39ca"
import script from "./companiesSettings.vue?vue&type=script&lang=js"
export * from "./companiesSettings.vue?vue&type=script&lang=js"
import style0 from "./companiesSettings.vue?vue&type=style&index=0&id=8c4b39ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports